import { events } from '../tracking/constants';

export const BOOKING_SUCCESS = `${events.USER_ACTION}.pmcdb.booking.success`;
export const DIRECTBOOK_DRAWER_CLOSED = `${events.USER_ACTION}.directbook_drawer.closed`;
